import * as yup from 'yup';

import {
  emailVerification,
  validateGiftRecipient,
} from '../../../utils/backend-api/groupSubscription';

export default function subscriptionEmailValidation() {
  return yup
    .string()
    .test('email validation', 'Please enter valid email address', async (email) => {
      const res = await emailVerification({
        email: email,
      });
      if (!res.success) {
        return false;
      }

      return true;
    })
    .test('validate', 'User is already a subscriber', async (email) => {
      const res = await validateGiftRecipient({
        email: email,
      });
      if (!res.success) {
        return false;
      }

      return true;
    })
    .required('Email address is required');
}
